import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings, toggleGlobal2fa } from "./redux/organizationsSagas";
import { getOrganizationObjects, organizationsApi } from "./api";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Add } from "./smartComponents/Add";
import { Edit } from "./smartComponents/Edit";
import { usePopup } from "../../../hooks/usePopup";
import { Delete } from "./smartComponents/Delete";
import { Info } from "./smartComponents/Info";
import { requestWithDownload } from "../../../utils/request";
import { Edit as EditIcon, Dashboard, Trash } from "../../../assets/images/svg";
import "./organizations.scss";

export function OrganizationsModule({ params }) {
  const dispatch = useDispatch();

  const organizations = useSelector((state) => state.organizations.organizations);
  const { global2fa } = useSelector((state) => state.organizations.commonSettings);

  const isLoading = useSelector((state) => state.organizations.isLoading);

  const [selectedOrg, setSelectedOrg] = useState("");

  const { popup, openPopup, closePopup } = usePopup(["add", "edit", "delete"]);
  const [info, setInfo] = useState({});

  const handleInfo = async (id) => {
    if (id === info.id) {
      setInfo({});
    } else {
      setInfo({ id });
      let data = await getOrganizationObjects(id);
      setInfo({ id, data });
    }
  };

  const handlePopup = (item, type) => {
    setSelectedOrg(item);

    openPopup(type);
  };

  useEffect(() => {
    dispatch(fetchSettings(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation uiLoader />
      </div>
    );

  const change2fa = () => {
    dispatch(toggleGlobal2fa(global2fa));
  };

  const exportActive = () => {
    requestWithDownload(organizationsApi.exportActive, "active_organizations");
  };

  return (
    <div id="admin-organizations">
      <div className="admin-organizations">
        <div className="admin-organizations__top">
          <button onClick={() => openPopup("add")} className="button button--primary">
            Add New Organization
          </button>

          <button onClick={exportActive} className="button button--primary">
            Export Active Organizations
          </button>

          <button onClick={change2fa} className="button button--primary">
            {global2fa ? "Disable " : "Enable "}
            Global 2FA
          </button>
        </div>

        <div className="admin-organizations__content">
          <ul className="group">
            {organizations.map((org) => {
              const {
                id,
                businessName,
                dashboardLink,
                statuses: { isHistorical, isHourly, isInactive, isReadyToDelete }
              } = org;

              return (
                <Fragment key={id}>
                  <li color="dark" className="group__item" onClick={() => handleInfo(id)}>
                    <div className="group__el text">
                      {businessName}
                      <span className="tags">
                        {isHistorical && " [Historical] "}
                        {isHourly && " [Hourly] "}
                        {isInactive && " [Deactivated] "}
                      </span>
                    </div>

                    <div className="group__el">
                      <a
                        className="group__icon"
                        href={dashboardLink}
                        onClick={(e) => e.stopPropagation()}
                        title="Open Dashboard"
                      >
                        <Dashboard />
                      </a>
                    </div>

                    <div className="group__el edit">
                      <span
                        className="group__icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePopup(org, "edit");
                        }}
                        title="Edit"
                      >
                        <EditIcon />
                      </span>
                    </div>

                    {isReadyToDelete && (
                      <div className="group__el">
                        <span
                          className="group__icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePopup(org, "delete");
                          }}
                          title="Delete"
                        >
                          <Trash color="#FF0000" />
                        </span>
                      </div>
                    )}
                  </li>
                  {info.id && id === info.id ? <Info data={info.data} /> : null}
                </Fragment>
              );
            })}
          </ul>
        </div>

        {popup.add && <Add isOpen={popup.add} onClose={closePopup("add")} />}

        {popup.edit && (
          <Edit isOpen={popup.edit} onClose={closePopup("edit")} selected={selectedOrg} />
        )}

        {popup.delete && (
          <Delete isOpen={popup.delete} onClose={closePopup("delete")} selected={selectedOrg} />
        )}
      </div>
    </div>
  );
}
